import React from 'react'
import "../Assets/styles/team.css"
import Teamer from 'src/Components/Team'
import { AiOutlineTeam } from "react-icons/ai";



const Team = () => {
  return (
    <>  
      <div className="anon">
      <div className='anon-bg'>
      <h1><AiOutlineTeam/></h1>
      <h4><a href='/home'>Home </a><span className='dot'></span> Team</h4>
      </div>
      </div>
      <Teamer/>
    </>
  )
}

export default Team